<template lang="pug">
  .object-investment
    .object-investment__top
      .object-investment__title.semibold Сведения об инвестициях
      button.reset-btn.button.button_add.button_small.button_icon(
        @click="showModal = true"
      )
    .table.object-investment__table
      .table__row
        .table__col.table__head Инвестиции
        .table__col.table__head Год
        .table__col.table__head
      .table__body
        .table__row(v-for="item in investments")
          .table__col {{item.investment_information}}
          .table__col {{item.year_investment}}
          .table__col
            .table__buttons
            button.row-edit.reset-btn.button.button_edit.button_small.button_icon.table__button(
              @click="editItem(item)"
            )
            button.row-delete.reset-btn.button.button_delete.button_small.button_icon.table__button(
              @click="deleteItem(item.id)"
            )
    e-modal(v-if="showModal"
      @close="showModal = false"
      @confirm="saveInvestment"
      :autoHeight="true"
      title="Сведения об инвестициях"
    )
      slot
      .body
        .e-form-group.form-group.col-block
          label.label Год
          input.input(v-model="investment.year_investment")
        .e-form-group.form-group.col-block
          label.label Инвестиции
          input.input(v-model="investment.investment_information")
</template>
<script>
import { tko } from '@/api/api-endpoints'
import year from '@/utils/year'

export default {
  name: 'object-investment',
  data() {
    return {
      investments: [],
      investment: {
        id: null,
        investment_information: '',
        year_investment: year.getCurrentYear(),
        tko_object_id: this.$route.params.id,
      },
      showModal: false,
    }
  },
  methods: {
    async getObjectInvestment() {
      this.investments = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.objectsInvestment({
            query: { tko_object_id: this.$route.params.id },
          }),
        })
      ).data.data
    },
    async saveInvestment() {
      const data = {
        investment_information: this.investment.investment_information,
        tko_object_id: this.$route.params.id,
        year_investment: this.investment.year_investment,
      }
      if (this.investment.id) {
        await this.$store.dispatch('updateModel', {
          url: tko.objectsInvestmentById(this.investment.id),
          data,
        })
      } else {
        await this.$store.dispatch('createModel', {
          url: tko.objectsInvestment(),
          data,
        })
      }
      this.investment.investment_information = ''
      this.showModal = false
      this.getObjectInvestment()
    },
    async deleteItem(id) {
      this.$e.confirmBox('Запись будет удалена').then(async () => {
        await this.$store.dispatch('deleteModel', {
          url: tko.objectsInvestmentById(id),
        })
        this.getObjectInvestment()
      })
    },
    editItem(item) {
      this.showModal = true
      this.investment = item
    },
  },
  created() {
    this.getObjectInvestment()
  },
}
</script>
